import SharedPropsService from "../../SharedPropsService";
import { rebuildActiveCustomerMobileCardBuilder, rebuildActiveCustomerTable, searchObject, sideBarNavigate, sortPartnerObjectByProperty } from "../partnerWeb_Dashboard/utils";
import { ROUTE } from "../../routes";
import sharedPropsService from "../../SharedPropsService";
import { partnerApi, StoreKey } from "../../configs/api";
import { VoltWebSiteBaseLink, getAppLinkOnBuildType } from "../../configs/constants";
import { getAppHeader } from "../../configs/config";
import { isPartnerAffiliated } from "../../configs/utils";
import AsyncStorage from "@react-native-async-storage/async-storage";
let PartnerActiveCustomerDataOriginal = {
    customerMetadataList: [],
    nextToken: null,
};
let PartnerActiveCustomerData = [];
let tableSearchString_AC = '';
let ascOrder = true;
let counter = 0;
export const onSearchActiveCustomer = async (action, _datastore, standardUtilites) => {
    console.warn('**** onSearchActiveCustomer Action Triggered ****', action);
    tableSearchString_AC = action.payload.value;
    const user = await sharedPropsService.getUser();
    const partnerAccountType = user?.linkedPartnerAccounts[0].partnerAccountType;
    PartnerActiveCustomerData =
        PartnerActiveCustomerDataOriginal?.customerMetadataList.filter(data => {
            console.log('filter Data: ', data);
            if (searchObject(data, tableSearchString_AC) &&
                searchObject(data, tableSearchString_AC).length > 0) {
                return true;
            }
            else {
                return false;
            }
        });
    console.log('mockDATA: ', PartnerActiveCustomerData);
    if (action?.payload?.widgetId === 'activeCustomerMobRootSearchInput') {
        await rebuildActiveCustomerMobileCardBuilder(standardUtilites, PartnerActiveCustomerData, partnerAccountType);
    }
    else {
        await rebuildActiveCustomerTable(standardUtilites, PartnerActiveCustomerData, action, partnerAccountType);
    }
};
export const onSortActiveCustomer = async (action, _datastore, standardUtilites) => {
    console.warn('**** onSortActiveCustomer Action Triggered ****', action);
    const user = await sharedPropsService.getUser();
    const partnerAccountType = user?.linkedPartnerAccounts[0].partnerAccountType;
    PartnerActiveCustomerData = sortPartnerObjectByProperty(PartnerActiveCustomerData, action.payload.value, ascOrder);
    ascOrder = !ascOrder;
    await rebuildActiveCustomerTable(standardUtilites, PartnerActiveCustomerData, action, partnerAccountType);
};
export const onLoadActiveCustomer = async (action, _datastore, { navigate, goBack, setDatastore }) => {
    console.warn('**** onLoadActiveCustomer Action Triggered ****', action);
    PartnerActiveCustomerData = {
        ...(await SharedPropsService.getPartnerActiveCustomerList()),
    }?.customerMetadataList;
    PartnerActiveCustomerDataOriginal = {
        ...(await SharedPropsService.getPartnerActiveCustomerList()),
    };
};
export const onChangeTab = async (action, _datastore, standardUtilities) => {
    console.warn('**** onChangeTabAC Action Triggered ****', action);
    // await navigate(action.payload.routeId);
    await sideBarNavigate(standardUtilities, action);
};
export const onTrackCustomerJourney = async (action, _datastore, standardUtilities) => {
    console.warn('**** onTrackCustomerJourney leads Action Triggered ****', action);
    const user = action.payload.value;
    const borrowerAccountId = user?.creditApplication?.accountId;
    const name = user?.borrowerAccountProfile?.name;
    AsyncStorage.setItem("pljName", name);
    await standardUtilities.asyncStorage.set(StoreKey.PLJ_borrowerAccountId, borrowerAccountId);
    await standardUtilities.navigate(ROUTE.VOLT_APP, { borrowerAccountId: borrowerAccountId });
};
export const viewDetails = async (action, _datastore, standardUtilities) => {
    console.warn('**** viewDetails Action Triggered ****', action);
    const user = action?.payload.user;
    if (user) {
        standardUtilities.navigate(ROUTE.PARTNER_VIEW_DETAIL_LEAD, { user: user, activeCustomer: true });
    }
};
export const onShareLinkWithRef = async (action, _datastore, standardUtilities) => {
    standardUtilities.instrumentTrack("INVITE_CLIENT_BUTTON CLICKED", {
        "page": "active_customers"
    });
    console.warn('**** onShareLinkWithRef Action Triggered ****', action);
    const user = JSON.parse(await standardUtilities.asyncStorage.get(StoreKey.userContext));
    const refCode = user?.linkedPartnerAccounts[0]?.partnerCode;
    const link = `${VoltWebSiteBaseLink}?ref=${refCode}`;
    const accountId = user?.linkedPartnerAccounts[0]?.accountId;
    const partnerAccountType = user?.linkedPartnerAccounts[0]?.partnerAccountType;
    const header = await getAppHeader();
    header["X-AppPlatform"] = 'VOLT_WEB_APP';
    const responseInvestorLink = await standardUtilities.network.get(`${partnerApi.investorLink}${accountId}`, {
        headers: header
    }, async () => { return; }, {
        isPartnerPlatform: true
    });
    const _linkFromNetwork = responseInvestorLink.data.link;
    standardUtilities.navigate(ROUTE.INVITE_CLIENT, { _link: isPartnerAffiliated(partnerAccountType) ? _linkFromNetwork : link });
};
export const onRegisterLeads = async (action, _datastore, { navigate, instrumentTrack }) => {
    instrumentTrack("ASSISTED_JOURNEY_BUTTON_CLICKED", {
        "page": "active_customer"
    });
    await navigate(ROUTE.REGISTER_LEADS, {});
    // await standardUtilities.navigate(ROUTE.REGISTER_LEADS_SUCCESS, {});
};
export const navigateToInterestFilterScreen = async (action, _datastore, { navigate, instrumentTrack }) => {
    const currentActiveTab = action?.payload?.currentActiveTab;
    const searchText = action?.payload?.searchText;
    const filterObj = action?.payload?.filterObj;
    await navigate(ROUTE.INTEREST_FILTER_SCREEN, { searchText, filterObj });
};
export const navigateToCustomerFilterScreen = async (action, _datastore, { navigate, instrumentTrack }) => {
    const currentActiveTab = action?.payload?.currentActiveTab;
    const searchText = action?.payload?.searchText;
    const filterObj = action?.payload?.filterObj;
    await navigate(ROUTE.CUSTOMER_FILTER_SCREEN, { searchText, filterObj });
};
export const navigateToRenewalFilterScreen = async (action, _datastore, { navigate, instrumentTrack }) => {
    const currentActiveTab = action?.payload?.currentActiveTab;
    const searchText = action?.payload?.searchText;
    const filterObj = action?.payload?.filterObj;
    await navigate(ROUTE.RENEWAL_FILTER_SCREEN, { searchText, filterObj });
};
export const navigateToShortfallFilterScreen = async (action, _datastore, { navigate, instrumentTrack }) => {
    const currentActiveTab = action?.payload?.currentActiveTab;
    const searchText = action?.payload?.searchText;
    const filterObj = action?.payload?.filterObj;
    await navigate(ROUTE.SHORTFALL_FILTER_SCREEN, { searchText, filterObj });
};
export const viewCustomerDetails = async (action, _datastore, { navigate, instrumentTrack, setDatastore }) => {
    const currentActiveTabIndex = action?.payload?.currentActiveTabIndex;
    const customerViewData = action?.payload?.customerViewData;
    const numberOfFilterApplied = action?.payload?.numberOfFilterApplied;
    const filterObj = action?.payload?.filterObj;
    const currentPageCustomer = action?.payload?.currentPageCustomer;
    await navigate(ROUTE.CUSTOMER_VIEW_DETAILS_SCREEN, { currentActiveTabIndex, customerViewData, numberOfFilterApplied, filterObj, currentPageCustomer });
};
export const navigateCustomerJourney = async (action, _datastore, standardUtilities) => {
    const borrowerAccountId = action?.payload?.borrowerAccountId;
    const name = action?.payload?.name;
    AsyncStorage.setItem("pljName", name);
    await standardUtilities.asyncStorage.set(StoreKey.PLJ_borrowerAccountId, borrowerAccountId);
    await standardUtilities.navigate(ROUTE.VOLT_APP, { borrowerAccountId: borrowerAccountId });
};
export const navigateToCustomerScreen = async (action, _datastore, { navigate, instrumentTrack, setDatastore, network, asyncStorage }) => {
    if (action?.payload?.tabClicked === true)
        instrumentTrack('ALL_CUSTOMER_TAB_CLICKED');
    await setDatastore(action.routeId, 'customerDetailsTable', {
        currentPageCustomer: 0,
        actualPageSizeCustomer: 0,
        customerData: [],
        dataFetched: false,
        totalNoOfPages: 0,
        counter: counter++,
    });
    const currentPageCustomer = action?.payload?.currentPage;
    let searchText = action?.payload?.searchText || '';
    const user = JSON.parse(await asyncStorage.get(StoreKey.userContext));
    let partnerAccountId = user?.linkedPartnerAccounts[0].accountId;
    const pageNumber = currentPageCustomer || 1;
    const renderFilterSelected = action?.payload?.renderFilterSelected?.filter;
    let customerObject = {
        "filter": renderFilterSelected,
        "searchContent": `${searchText}`
    };
    // let customerObject = {};
    const response = await network.post(`${partnerApi.getAllCustomerList}${partnerAccountId}/partnerdashboard/all/${pageNumber}`, customerObject, {
        headers: await getAppHeader(),
    }, async () => { return; }, { isPartnerPlatform: true });
    if (response.status === 200) {
        await setDatastore(action.routeId, 'customerDetailsTable', {
            currentPageCustomer: response?.data?.currentPage,
            actualPageSizeCustomer: response?.data?.actualpageSize,
            customerData: response?.data?.data,
            dataFetched: true,
            totalNoOfPages: response?.data?.totalPages,
            counter: counter++,
        });
    }
};
export const navigateToInterestScreen = async (action, _datastore, { navigate, instrumentTrack, setDatastore, network, asyncStorage }) => {
    if (action?.payload?.tabClicked === true)
        instrumentTrack('INTEREST_DUE_TAB_CLICKED');
    await setDatastore(action.routeId, 'customerDetailsTable', {
        currentPageCustomer: 0,
        actualPageSizeCustomer: 0,
        customerData: [],
        dataFetched: false,
        totalNoOfPages: 0,
        counter: counter++,
    });
    const currentPageCustomer = action?.payload?.currentPage;
    const user = JSON.parse(await asyncStorage.get(StoreKey.userContext));
    let searchText = action?.payload?.searchText || '';
    let partnerAccountId = user?.linkedPartnerAccounts[0].accountId;
    const pageNumber = currentPageCustomer || 1;
    const renderFilterSelected = action?.payload?.renderFilterSelected?.filter;
    let customerObject = {
        "filter": renderFilterSelected,
        "searchContent": `${searchText}`
    };
    // let customerObject = {}
    const response = await network.post(`${partnerApi.getAllCustomerList}${partnerAccountId}/partnerdashboard/interestDue/${pageNumber}`, customerObject, {
        headers: await getAppHeader(),
    }, async () => { return; }, { isPartnerPlatform: true });
    if (response.status === 200) {
        await setDatastore(action.routeId, 'customerDetailsTable', {
            currentPageCustomer: response?.data?.currentPage,
            actualPageSizeCustomer: response?.data?.actualpageSize,
            customerData: response?.data?.data,
            dataFetched: true,
            totalNoOfPages: response?.data?.totalPages,
            counter: counter++,
        });
    }
};
export const navigateToRenewalScreen = async (action, _datastore, { navigate, instrumentTrack, setDatastore, network, asyncStorage }) => {
    if (action?.payload?.tabClicked === true)
        instrumentTrack('RENEWAL_DUE_TAB_CLICKED');
    await setDatastore(action.routeId, 'customerDetailsTable', {
        currentPageCustomer: 0,
        actualPageSizeCustomer: 0,
        customerData: [],
        dataFetched: false,
        totalNoOfPages: 0,
        counter: counter++,
    });
    const currentPageCustomer = action?.payload?.currentPage;
    const renderFilterSelected = action?.payload?.renderFilterSelected?.filter;
    const user = JSON.parse(await asyncStorage.get(StoreKey.userContext));
    let partnerAccountId = user?.linkedPartnerAccounts[0].accountId;
    const pageNumber = currentPageCustomer || 1;
    let searchText = action?.payload?.searchText || '';
    let customerObject = {
        "filter": renderFilterSelected,
        "searchContent": `${searchText}`
    };
    // let customerObject = {};
    const response = await network.post(`${partnerApi.getAllCustomerList}${partnerAccountId}/partnerdashboard/renewal/${pageNumber}`, customerObject, {
        headers: await getAppHeader(),
    }, async () => { return; }, { isPartnerPlatform: true });
    if (response.status === 200) {
        await setDatastore(action.routeId, 'customerDetailsTable', {
            currentPageCustomer: response?.data?.currentPage,
            actualPageSizeCustomer: response?.data?.actualpageSize,
            customerData: response?.data?.data,
            dataFetched: true,
            totalNoOfPages: response?.data?.totalPages,
            counter: counter++,
        });
    }
};
export const navigateToShortfallScreen = async (action, _datastore, { navigate, instrumentTrack, setDatastore, network, asyncStorage }) => {
    if (action?.payload?.tabClicked === true)
        instrumentTrack('SHORTFALL_TAB_CLICKED');
    await setDatastore(action.routeId, 'customerDetailsTable', {
        currentPageCustomer: 0,
        actualPageSizeCustomer: 0,
        customerData: [],
        dataFetched: false,
        totalNoOfPages: 0,
        counter: counter++,
    });
    const currentPageCustomer = action?.payload?.currentPage;
    const renderFilterSelected = action?.payload?.renderFilterSelected?.filter;
    const user = JSON.parse(await asyncStorage.get(StoreKey.userContext));
    let partnerAccountId = user?.linkedPartnerAccounts[0].accountId;
    const pageNumber = currentPageCustomer || 1;
    let searchText = action?.payload?.searchText || '';
    let customerObject = {
        "filter": renderFilterSelected,
        "searchContent": `${searchText}`
    };
    // let customerObject = {};
    const response = await network.post(`${partnerApi.getAllCustomerList}${partnerAccountId}/partnerdashboard/shortfall/${pageNumber}`, customerObject, {
        headers: await getAppHeader(),
    }, async () => { return; }, { isPartnerPlatform: true });
    if (response.status === 200) {
        await setDatastore(action.routeId, 'customerDetailsTable', {
            currentPageCustomer: response?.data?.currentPage,
            actualPageSizeCustomer: response?.data?.actualpageSize,
            customerData: response?.data?.data,
            dataFetched: true,
            totalNoOfPages: response?.data?.totalPages,
            counter: counter++,
        });
    }
};
export const navigateToInterestCalculatorScreen = async (action, _datastore, { navigate, instrumentTrack, setDatastore, network, asyncStorage }) => {
    await navigate(ROUTE.INTEREST_CALCULATOR);
};
export const onShareLinkWithCustomer = async (action, _datastore, standardUtilities) => {
    standardUtilities.instrumentTrack("INVITE_CLIENT_BUTTON CLICKED", {
        "page": "active_customers"
    });
    const customer = action?.payload?.customerViewData;
    const currentActiveTabIndex = action?.payload?.currentActiveTabIndex;
    const numberOfFilterApplied = action?.payload?.numberOfFilterApplied;
    const filterObj = action?.payload?.filterObj;
    const user = JSON.parse(await standardUtilities.asyncStorage.get(StoreKey.userContext));
    const refCode = user?.linkedPartnerAccounts[0]?.partnerCode;
    const phoneNumber = customer?.phoneNumber?.substr(3);
    let link = '';
    if (phoneNumber !== undefined)
        link = `${getAppLinkOnBuildType()}?user=${phoneNumber}`;
    else
        link = `${VoltWebSiteBaseLink}?ref=${refCode}`;
    const accountId = user?.linkedPartnerAccounts[0]?.accountId;
    const partnerAccountType = user?.linkedPartnerAccounts[0]?.partnerAccountType;
    const header = await getAppHeader();
    header["X-AppPlatform"] = 'VOLT_WEB_APP';
    const responseInvestorLink = await standardUtilities.network.get(`${partnerApi.investorLink}${accountId}`, {
        headers: header
    }, async () => { return; }, {
        isPartnerPlatform: true
    });
    const _linkFromNetwork = responseInvestorLink.data.link;
    standardUtilities.navigate(ROUTE.INVITE_CLIENT, { _link: isPartnerAffiliated(partnerAccountType) ? _linkFromNetwork : link, customer, currentActiveTabIndex, numberOfFilterApplied, filterObj, routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER });
};
